module.exports = __webpack_public_path__ + "img/coming-soon-2.ee4c8203.png";